var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.multiple)?_c('editable-select-multiple',{on:{"update":_vm.updateMultipleValues}}):_c('editable-select-single',{on:{"update":_vm.updateSingleValue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }